import React from "react"

const Location = () => {
  return (
    <svg
      width="20"
      height="26"
      viewBox="0 0 20 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.7257 25.2641C9.7257 25.2641 19.0578 15.8941 19.0578 10.1549C19.0578 4.27161 14.2355 0.856934 9.7257 0.856934C5.21594 0.856934 0.393555 4.27161 0.393555 10.1549C0.393555 15.8941 9.7257 25.2641 9.7257 25.2641ZM9.72546 13.7784C11.7078 13.7784 13.3147 12.1714 13.3147 10.1891C13.3147 8.20682 11.7078 6.59985 9.72546 6.59985C7.74316 6.59985 6.13618 8.20682 6.13618 10.1891C6.13618 12.1714 7.74316 13.7784 9.72546 13.7784Z"
        fill="#34A0B6"
      />
    </svg>
  )
}

export default Location
